import React from "react"
import PropTypes from "prop-types"
import exact from "prop-types-exact"
import Paper from "@mui/material/Paper"

const RoundedCard = ({ children, style, className }) => (
  <Paper className={`floating-box ${className}`} style={{ ...style }}>
    {children}
  </Paper>
)

RoundedCard.propTypes = exact({
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
})
RoundedCard.defaultProps = {
  style: null,
  className: null,
}

export default RoundedCard
